import axios from "axios";
import { baseURL } from "./init.js";

export async function getAllMembers() {
   try {
      const response = await axios.get(`${baseURL}/members`);
      return response.data.members || [];
   } catch (error) {
      return [];
   }
}

export const getCountryStats = async () => {
  const res = await axios.get(`${baseURL}/members/countries`);
  return res.data;
};